import React from 'react'
import AboutTabPointing from './AboutTabPointing.js'

const MainContent = (props) => (
  <div className="main-content">
  	<AboutTabPointing {...props}/>
  </div>
)

export default MainContent


// WEBPACK FOOTER //
// ./src/components/MainContent.js